import React from "react";

/**
 * Nav mark — official logo (crescent + arrow), served from /logo-mark.png.
 * Ink on paper. Not animated, not in a circle.
 */
export default function Mark({ size = 16, className = "" }) {
  return (
    <img
      src="/logo-mark.png"
      alt="Nav"
      width={size * 1.6}
      height={size}
      className={className}
      data-testid="nav-mark"
      style={{ display: "block", objectFit: "contain" }}
    />
  );
}
